export default __webpack_public_path__ + "static/sidebar1-19a1c4017f24d1f0456e6d996c531d1a.png";